import { MEDIA_FLAGGING } from 'src/common/types/media';

// 5 is reserved: production has a legacy row with that value.
const TOS_EQUIVALENT_FLAGS: readonly number[] = [
  MEDIA_FLAGGING.TOS_VIOLATION,
  MEDIA_FLAGGING.CHILD_EXPLOITATION,
  MEDIA_FLAGGING.TERRORISM,
  MEDIA_FLAGGING.VIOLENCE_GORE,
  MEDIA_FLAGGING.SELF_HARM,
  MEDIA_FLAGGING.HATE,
  MEDIA_FLAGGING.HARASSMENT,
  MEDIA_FLAGGING.ILLEGAL_GOODS,
  MEDIA_FLAGGING.IP,
];

export const isTosViolation = (flagged?: number | null) =>
  TOS_EQUIVALENT_FLAGS.includes(flagged ?? MEDIA_FLAGGING.NONE);
